import { TableColumn } from '../../../components/forms/form-entries/form-entry-list/entry-list/dynamic-table/dynamic-table.component';
import { FallProtectionPlan } from './fall-protection-plan.model';

export class FallProtectionPlanListItem {
  /** When the form was submitted ("Entry Date" column) */
  submissionDate: Date | null = null;

  /** The person who submitted the form ("User" column) */
  submittedByName: string | null = null;

  /** The plan date */
  date: Date | null = null;

  /** Project information */
  project: string | null = null;
  jobsiteAddress: string | null = null;

  /** Fall Hazards */
  perimeterEdge: boolean | null = null;
  otherFallHazardSpecify: string | null = null;

  id: string = '';

  constructor(data?: Partial<FallProtectionPlanListItem>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  static getTableColumns(): TableColumn[] {
    const columns: TableColumn[] = [];
    const instance = new FallProtectionPlanListItem();
    const fieldMappings = FallProtectionPlan.getFieldMappings();
    
    // Get all properties of the class
    Object.keys(instance).forEach(key => {
      // Skip the id property as it's handled separately
      if (key === 'id') return;

      // Determine the type based on the property value
      let type: 'text' | 'date' | 'action' | 'status' = 'text';
      const value = instance[key as keyof FallProtectionPlanListItem];
      
      if (value instanceof Date || (value === null && key.toLowerCase().includes('date'))) {
        type = 'date';
      }
      // All other values default to 'text' type

      // Add the column if it has a mapping
      if (fieldMappings[key]) {
        columns.push({
          key,
          label: fieldMappings[key],
          type,
          sortable: true
        });
      }
    });

    

    return columns;
  }

  static fromApiResponse(data: any): FallProtectionPlanListItem {
    return new FallProtectionPlanListItem({
      id: data.id,
      submissionDate: data.submissionDate ? new Date(data.submissionDate) : null,
      submittedByName: data.submittedByName,
      date: data.date ? new Date(data.date) : null,
      project: data.project,
      jobsiteAddress: data.jobsiteAddress,
      perimeterEdge: data.perimeterEdge,
      otherFallHazardSpecify: data.otherFallHazardSpecify
    });
  }
} 